export const BASE_URL = import.meta.url;
export const X_API_KEY = 'af5a5a78-e4ce-47e4-a751-99b7fdaa82d2';
